export default __webpack_public_path__ + "static/media/information--passenger-loading-zone--g1.ab94bd58.png";